import Container from "./Container";

export default function Dropdown({menuType, handleMenu}) {
  return <Container menuType={menuType} handleMenu={handleMenu} />;
}
